import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Approveimg from '../../assets/images/Approvd.png';
import Deniedimg from '../../assets/images/Denied.png';
import { approveTicket } from '../../services/ticket';

export const ThankYouTicket = () => {
  const [success, setSuccess] = useState();

  const { ticketId } = useParams();
  const [searchParams] = useSearchParams();

  const isApprove = searchParams.get("approved"); 

  const SubmitApproval = async () => {

    try {
      const response = await approveTicket(ticketId);

      if (response.status === 200) {
        setSuccess(true);
      } else {
        setSuccess(false);
      }
    } catch (error) {
      setSuccess(false);
    }
  };

  useEffect(() => {
    if (ticketId && isApprove !== null) {
      SubmitApproval();
    }
  }, []);

  return (
    <>
      {isApprove  ? (
          <img src={Approveimg} alt="approved" height="100%" width="100%" />
        ) : (
          <img src={Deniedimg} alt="denied" height="100%" width="100%" />
        )
      }
    </>
  );
};